function CalculateRow({ children, className = '' }) {
  return <div className={`flex justify-between items-center py-4 ${className}`}>{children}</div>
}

export default CalculateRow
